<template>
  <div
    class="scale-item text-textLight text-body-3"
    @mouseover="mouseOver = true"
    @mouseenter="editorAction({ action: 'Inclusivity Meter hovered' })"
    @mouseleave="mouseOver = false"
  >
    <div class="scale-line">
      <InclusionMeter
        v-if="scale.value"
        :value="scale.value"
        :hide-color="hideColor"
      />
    </div>
    <div
      v-if="scale.value === 1 && mouseOver"
      class="scale-description scale-description-1 green-solid"
    >
      <div class="rel">
        <div>Most job seekers are likely to see this job as open and approachable.</div>
      </div>
    </div>
    <div
      v-if="scale.value === 2 && mouseOver"
      class="scale-description scale-description-2 green-solid"
    >
      <div class="rel">
        <div>
          Many job seekers will find the job approachable, though some wording could be refined.
        </div>
      </div>
    </div>
    <div
      v-if="scale.value === 3 && mouseOver"
      class="scale-description scale-description-3 red-solid"
    >
      <div class="rel">
        <div>
          Some job seekers may not see themselves fitting the role as written.
        </div>
      </div>
    </div>
    <div
      v-if="scale.value === 4 && mouseOver"
      class="scale-description scale-description-4 red-solid"
    >
      <div class="rel">
        <div>
          A significant number of job seekers may feel the role is not meant for them.
        </div>
      </div>
    </div>
    <div
      v-if="scale.value === 5 && mouseOver"
      class="scale-description scale-description-5 red-solid"
    >
      <div class="rel">
        <div>
          Most job seekers are likely to see this job as exclusive.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import InclusionMeter from '@/components/editor/InclusionMeter.vue';
import { useTracking } from '@/stores/tracking/tracking';
import { useEditor } from '@/stores/editor/editor';

export default {
  name: 'InclusionScale',
  components: {
    InclusionMeter,
  },
  props: {
    scale: { type: Object, default: () => ({}) },
    labelLeft: { type: String, default: '' },
    labelRight: { type: String, default: '' },
  },
  data() {
    return {
      mouseOver: false,
    };
  },
  computed: {
    ...mapState(useEditor, ['loadingAnimation']),
    hideColor() {
      return !this.loadingAnimation.sidebar && this.loadingAnimation.showAnimation;
    },
  },
  methods: {
    ...mapActions(useTracking, ['editorAction']),
    getClass(id) {
      if (id === this.scale.value) {
        return 'active';
      }
      return false;
    },
  },
};
</script>

<style lang="less" scoped>
.scale-item {
  padding: 0;
  margin: 0;
  position: relative;
}
.scale-text {
  display: flex;
  justify-content: space-between;
  padding: 6px 0 8px 0;
  font-size: 12px;
  font-weight: 300;
  margin: 0;
}
.scale-text > div {
  flex: 1;
  text-align: center;
}
.scale-text > div:first-child {
  text-align: left;
}
.scale-text > div:last-child {
  text-align: right;
}
.scale-text .link-text:hover {
  color: @text-darkest;
  text-decoration: underline;
}
.scale-line {
  display: flex;
}
.scale-line > div {
  flex: 1;
  margin: 0 1px;
  position: relative;
}
.scale-line > div span {
  display: block;
  height: 33px;
  position: relative;
  overflow: hidden;
}
.scale-line > div span:before {
  content: "";
  position: absolute;
  left: -50px;
  right: -50px;
  height: 33px;
}
.scale-line > div:nth-child(1) span:before {
  bottom: -18px;
  background: #0BB88B;
  opacity: .8;
}
.scale-line > div:nth-child(2) span:before {
  bottom: -20px;
  background: #0BB88B;
  opacity: .5;
}
.scale-line > div:nth-child(3) span:before {
  bottom: -22px;
  background: #DF575A;
  opacity: .3;
}
.scale-line > div:nth-child(4) span:before {
  bottom: -24px;
  background: #DF575A;
  opacity: .5;
}
.scale-line > div:nth-child(5) span:before {
  bottom: -26px;
  background:#DF575A;
  opacity: .8;
}
.scale-line > div.active:after {
  content: "";
  position: absolute;
  left: 50%;
  margin-left: -5px;
}
.scale-line > div:nth-child(1).active:after {
  top: 4px;
}
.scale-line > div:nth-child(2).active:after {
  top: 6px;
}
.scale-line > div:nth-child(3).active:after {
  top: 8px;
}
.scale-line > div:nth-child(4).active:after {
  top: 10px;
}
.scale-line > div:nth-child(5).active:after {
  top: 12px;
}
.scale-line > div.active ~ div span:before {
  background: #fff;
}
.scale-description {
  position: absolute;
  top: 12px;
  background: #fff;
  z-index: 5;
  margin-top: 5px;
  white-space: normal;
  text-align: center;
  padding: 10px;
  width: 190px;
  max-width: 190px;
  border-radius: 12px;
  box-shadow: 0 0 50px 0 fade(@grey-900, 10%);
}
.scale-description-1 {
  left: -2px;
}
.scale-description-2 {
  left: 32px;
}
.scale-description-3 {
  right: -2px;
}
.scale-description-4 {
  right: 36px;
}
.scale-description-5 {
  right: -2px;
}
.scale-description-1:after {
  left: 18px;
}
.scale-description-2:after {
  left: 36px;
}
.scale-description-3:after {
  left: 50px;
}
.scale-description-4:after {
  right: 32px;
}
.scale-description-5:after {
  right: 18px;
}
.icon {
  vertical-align: top;
  width: 21px;
  position: absolute;
  left: 50%;
  top: -11px;
  margin: 0 0 0 -9px;
  font-weight: 400 !important;
  font-size: 17px;
}
.scale-type {
  padding: 5px 10px;
  color: #fff;
  display: none;
  background-color: @basic-green;
}

.red-solid .scale-line:before {
  background: #df565a;
}
.red-solid .icon {
  color: #df565a;
}
.green-solid .scale-line:before {
  background: @basic-green;
}
.green-solid .icon {
  color: @basic-green;
}
</style>
